import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../shared/auth.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private router: Router,
  ) { }

  authForm: FormGroup;
  hide: boolean;

  ngOnInit() {
    this.authService.loggedSubs.subscribe(logged => {
      if (logged) {
        this.router.navigate(['/sbp']);
      }
    });

    this.authForm = new FormGroup({
      username: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', Validators.required)
    });

  }

  login() {
    this.authService.login({
      username: this.authForm.value.username,
      password: this.authForm.value.password
    });
  }

}
